import React, { useContext, useMemo, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import '../css/StudentAssignmentTile.less';

// import defaultCardImage from '../img/default-assessment.svg';
import iconLaunchSrc from '../img/icon-launch.svg';
import iconLaunchDisabledSrc from '../img/icon-launch-disabled.svg';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import ImageService from '../services/ImageService';
import StudentAssignmentService from '../services/StudentAssignmentService';
import UtilityService from '../services/UtilityService';

const StudentAssignmentTile = observer((props) => {
  const { additionalClassNames, assignment, menuStatus, t } = props;

  const { assignmentManager, userManager } = useContext(MobXProviderContext);

  // cache each component via useMemo to avoid re-mounting on every render
  const DotMenu = useMemo(() => SatCoreComponent('DotMenu'), []);
  const StudentAssignmentDetailsPopup = useMemo(() => SatCoreComponent('StudentAssignmentDetailsPopup'), []);
  const StudentAssignmentPrimaryActionButton = useMemo(() => SatCoreComponent('StudentAssignmentPrimaryActionButton'), []);
  const StudentAssignmentTitlePopup = useMemo(() => SatCoreComponent('StudentAssignmentTitlePopup'), []);
  // TODO DEMO-3099: currently out of scope for StudentAssignmentTile
  // const StudentAssignmentTryAgainButton = useMemo(() => SatCoreComponent('StudentAssignmentTryAgainButton'), []);

  const [dotMenuOpen, setDotMenuOpen] = useState(false);

  if (!assignment || assignment.visibilityMode === 'hidden_from_students') {
    return null;
  }

  const title = StudentAssignmentService.getStudentAssignmentTitle(assignment, {
    preferStudentAssignmentNickname: assignmentManager.useAssignmentNickname
  });
  const parsedTitle = UtilityService.reactHtmlParserWrapper(title).parsed;
  const { dueDateText, dueDateType, timezoneAbbreviation } = StudentAssignmentService.getStudentAssignmentDueDateLabel(assignment, {
    timezone: userManager.user?.timezone
  });
  // TODO DEMO-3099: currently out of scope for StudentAssignmentTile
  // const { assignmentGrade, assignmentGradeClassName, assignmentGradeKey } =
  //   StudentAssignmentService.getStudentAssignmentGradeInfo(assignment);

  const renderStudentAssignmentTile = () => {
    return (
      <div className={classNames('StudentAssignmentTile', additionalClassNames)}>
        {renderStudentAssignmentTileHeader()}
        {renderStudentAssignmentTileImage()}
        {renderStudentAssignmentTileFooter()}
      </div>
    );
  };

  const renderStudentAssignmentTileHeader = () => {
    return (
      <div className='student-assignment-tile-header'>
        <StudentAssignmentTitlePopup
          assignment={assignment}
          popupOptions={{
            position: 'bottom center',
            trigger: (
              <div className='student-assignment-tile-title'>
                {parsedTitle}
              </div>
            )
          }} />
      </div>
    );
  };

  const renderStudentAssignmentTileImage = () => {
    // note: per DEMO-3099, when no image is supplied, the current design (by default)
    // utilizes a solid background color rather than the typical default assignment image.
    // const defaultImg = assignmentManager.customDefaultAssignmentCardImg || defaultCardImage;
    const defaultImg = null;
    return (
      <div className='student-assignment-tile-image'>
        <img
          alt=''
          src={ImageService.getImageUrl(assignment) || defaultImg} />
      </div>
    );
  };

  const renderStudentAssignmentTileFooter = () => {
    return (
      <div className='student-assignment-tile-footer'>
        {renderStudentAssignmentDueDate()}
        {/* TODO DEMO-3099: currently out of scope for StudentAssignmentTile */}
        {/* {renderStudentAssignmentGrade()} */}
        {renderStudentAssignmentActionButtons()}
        {renderStudentAssignmentDotMenu()}
      </div>
    );
  };

  const renderStudentAssignmentDueDate = () => {
    return (
      <div className={classNames('student-assignment-tile-due-date', dueDateType)}>
        {!!dueDateText && t('dueDateLabel', { dateText: dueDateText, timezoneAbbreviation })}
      </div>
    );
  };

  // TODO DEMO-3099: currently out of scope for StudentAssignmentTile
  // const renderStudentAssignmentGrade = () => {
  //   if (!assignmentGrade && !assignmentGradeKey) {
  //     return null;
  //   }
  //   return (
  //     <div className={classNames('student-assignment-tile-grade', assignmentGradeClassName)}>
  //       {assignmentGrade || t(assignmentGradeKey)}
  //     </div>
  //   );
  // };

  const renderStudentAssignmentActionButtons = () => {
    return (
      <div className='student-assignment-tile-actions'>
        <StudentAssignmentPrimaryActionButton
          assignment={assignment}
          icon={iconLaunchSrc}
          iconDisabled={iconLaunchDisabledSrc}
          menuStatus={menuStatus} />
        {/* TODO DEMO-3099: currently out of scope for StudentAssignmentTile */}
        {/* {StudentAssignmentService.isStudentAssignmentTryAgainEligible(assignment) && ( */}
        {/*   <StudentAssignmentTryAgainButton assignment={assignment} /> */}
        {/* )} */}
      </div>
    );
  };

  const renderStudentAssignmentDotMenu = () => {
    return (
      <div className='student-assignment-tile-dot-menu-wrapper'
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}>
        <StudentAssignmentDetailsPopup
          assignment={assignment}
          popupOptions={{
            onClose: () => setDotMenuOpen(false),
            onOpen: () => setDotMenuOpen(true),
            open: dotMenuOpen,
            position: 'bottom center',
            trigger: (
              <DotMenu
                ariaLabel={t('moreOptions')}
                clickMenu={() => setDotMenuOpen((prev) => !prev)} />
            )
          }}
          timezoneAbbreviation={timezoneAbbreviation} />
      </div>
    );
  };

  return renderStudentAssignmentTile();
});
export default StudentAssignmentTile;

SatCoreRegister('StudentAssignmentTile', StudentAssignmentTile);
